import { atom } from "recoil";
import { Banner } from "apis/site";

export const bannerState = atom<Banner[]>({
  key: "bannerState",
  default: [],
});

export const bannerLoadingState = atom<boolean>({
  key: "bannerLoadingState",
  default: false,
});

export const bannerFetchedState = atom<boolean>({
  key: "bannerFetchedState",
  default: false,
});
